module.exports = __webpack_public_path__ + "img/abkhazia.5c15814c.png";